import { Type } from 'class-transformer'
import { BaseEntity, SpecificField, type Searchable } from './base'
import type { RoleRow } from './role'

export class RecordTypeRow extends BaseEntity implements Searchable {
  displayName!: string
  tabular!: boolean

  get searchString() {
    return this.displayName
  }
}

export class RecordType extends RecordTypeRow {
  @Type(() => SpecificField)
  specificFields!: SpecificField[]
}

export class RecordTypeDetails extends RecordType {
  readRoles!: RoleRow[]
  writeRoles!: RoleRow[]
}

export class WriteRecordType {
  displayName!: string
  tabular!: boolean
}

export class AddLinkedRole {
  roleId!: string
}

export interface GetRecordTypes {
  recordTypes: RecordTypeRow[]
}
export interface RecordTypeWritten {
  recordType: RecordTypeRow
}
export interface GetRecordType {
  recordType: RecordTypeDetails
}

export class NewAssignedRecordType {
  recordTypeId!: string
}

export class BaseAssignedRecordType extends BaseEntity {
  recordTypeId!: string
  sortIndex!: number
}

export class AssignedRecordType extends BaseAssignedRecordType {
  @Type(() => RecordTypeRow)
  recordType!: RecordTypeRow

  get searchString() {
    return this.recordType.searchString
  }
}

export class SortAssignedRecordTypes {
  sortedIds!: string[]
}

export interface GetAvailableRecordTypes {
  recordTypes: RecordType[]
}
